import { render, staticRenderFns } from "./CompleteInvoicesAlt.yaml?vue&type=template&id=4a7aaff1&component"
import script from "./CompleteInvoicesAlt.yaml?vue&type=script&lang=ts&component"
export * from "./CompleteInvoicesAlt.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports